/* eslint-disable linebreak-style */
import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../styles/common/form.styles';

export const MultiSelectStyles = css`
  ${genericFormStyling}
  .fast-listbox > .fast-checkbox-option {
    padding: 8px 12px;
    height: 30px;
    display: flex;
  }

  .fast-listbox {
    margin: 0;
    min-width: 208px;
    border: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-rest);
    border-radius: calc(var(--control-corner-radius) * 1px);
    box-sizing: border-box;
    background: #282e33;
    box-shadow: none;
    max-height: 200px;
    overflow: auto;
    margin-top: 0;
    z-index: 100;
  }

  .custom-input-search {
    display: grid;
    position: relative;
  }

  .clt-checkbox {
    height: 16px;
    width: 16px;
    background-color: #1f2126;
    border-radius: 3px;
    padding: 3px;
    float: left;
    margin-right: 8px;
    border: 1px solid #71818b;
    color: transparent;
  }

  zero-button {
    position: absolute;
    right: 0;
    background-color: rgba(135, 155, 166, 0.1);
    height: -webkit-fill-available;
    margin: 3px;
    aspect-ratio: 1 / 1;
    min-width: 25px;
    z-index: 2;
  }

  zero-text-field {
    padding-bottom: 0 !important;
  }

  zero-text-field::part(label) {
    padding-left: 0px;
    margin: 0px;
  }

  zero-text-field::part(end) {
    background: #879ba60f;
  }

  zero-text-field:focus-within::part(root) {
    box-shadow: none;
  }

  zero-text-field:focus-within::part(end) {
    background: #121212;
    height: 38px;
  }

  .custom-input-search zero-text-field::part(end) {
    margin-inline-end: 0;
    border-radius: 0;
    height: 25px;
  }

  .custom-input-search zero-text-field::part(control) {
    border-radius: 0;
  }

  :host(.card-version) .custom-input-search zero-text-field::part(root) {
    --design-unit: 2.9;
  }

  :host(.card-version) .custom-input-search zero-text-field::part(end) {
    height: 25px;
  }

  :host(.card-version) .custom-input-search zero-button {
    --design-unit: 2.6;
  }

  :host(.card-version-market-depth) .custom-input-search zero-text-field::part(root) {
    --design-unit: 3;

    height: 40px;
    min-width: 150px;
  }
`;
